import Vue from 'vue';
import { formatNumber } from 'libphonenumber-js';

Vue.filter('phone', (phone) => formatNumber(phone, 'PL', 'National'));
Vue.filter('phoneInternational', (phone) => formatNumber(phone, 'PL', 'International'));
